<template>
  <!-- <keep-alive> -->
  <router-view />
  <!-- </keep-alive> -->
</template>

<script>
import pageComponent from '@/mixins/page-component';

export default {
  name: 'RestResourcesIndexParentPage',
  // mixins: [require('@/mixins/hooks-log').default], // eslint-disable-line
  // beforeRouteEnter(to, from, next) {
  //   console.log('RestResourcesIndexParentPage', 'beforeRouteEnter');
  //   next();
  // },
  mixins: [pageComponent],
  inject: ['config'],
  computed: {
    namespace() { return `${this.config.store.namespace}/Index`; },
  },
  created() {
    const { store, server } = this.config;
    const { modules } = store;
    this.$store.registerModule(this.namespace.split('/'), modules.index({ ...store, server }));
  },
  destroyed() {
    this.$store.unregisterModule(this.namespace.split('/'));
  },
};
</script>
